import { fetchApi } from "@/api/client";
import type {
  AssignmentResponse,
  GeneratePreviewsRequest,
  GeneratePreviewsResponse,
  JobStatusResponse,
} from "@/types/previews";

export const API_THEME_PREVIEWS_PATH = "/api/theme-previews" as const;
export const API_THEME_PREVIEWS_ASSIGNMENTS_PATH =
  "/api/theme-previews/assignments" as const;

export function themePreviewJobPath(jobId: string): string {
  return `${API_THEME_PREVIEWS_PATH}/${encodeURIComponent(jobId)}`;
}

export async function triggerPreviewGeneration(
  req: GeneratePreviewsRequest,
): Promise<GeneratePreviewsResponse> {
  return fetchApi<GeneratePreviewsResponse>(API_THEME_PREVIEWS_PATH, {
    method: "POST",
    body: JSON.stringify(req),
  });
}

export async function getJobStatus(
  jobId: string,
): Promise<JobStatusResponse> {
  return fetchApi<JobStatusResponse>(themePreviewJobPath(jobId));
}

export async function listAssignments(): Promise<readonly AssignmentResponse[]> {
  return fetchApi<readonly AssignmentResponse[]>(
    API_THEME_PREVIEWS_ASSIGNMENTS_PATH,
  );
}
